import { render, staticRenderFns } from "./BarcodeModal.vue?vue&type=template&id=2996d67e&scoped=true&"
import script from "./BarcodeModal.vue?vue&type=script&lang=js&"
export * from "./BarcodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2996d67e",
  null
  
)

export default component.exports